/** Background notifications carrying a call state; both share one payload shape (`direction`). */
export const TELEPHONY_CALL_STATE_CHANGED_NOTIFICATION_TYPES = [
  'telephony-outbound_call_state_changed',
  'telephony-inbound_call_state_changed',
] as const;
